import { httpClient } from "../setupAxios";

export function tenantSignUp(newTenant) {
  return httpClient.post("/v1/boff/tenants/register/sign-up", newTenant);
}
